<div class="field-activity-header" #parent [ngStyle]="{ 'width': config.width,'height': config.height}">
  <div  class="container" [ngStyle]="{'left': positionHeader + '%'}" >
    <div #child  class="header" [ngStyle]="{'grid-template-columns': 'repeat(' + (headers.length) + ', 1fr)', 'width': width}">
      <div class="item-header" *ngFor="let header of headers; let colIndex = index">
        <div class ="header-title" ><div class="title" >{{header}}</div></div>
      </div>
    </div>
  </div>
</div>